import { jsx as l } from "react/jsx-runtime";
const e = (c) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "#2FC774",
        d: "M6.525 20.275Q9.262 20.5 12 20.5c1.825 0 3.65-.075 5.475-.2 2.35-.2 4.2-2.25 4.375-4.85l.015-.208c.09-1.258.135-1.886.135-3.19V9.527l-3.25 2.825c-.023 1.198.027 1.512-.05 2.536l-.027.354c-.075.975-.675 1.775-1.4 1.825-3.5.3-6.998.282-10.498-.018-.725-.05-1.325-.85-1.4-1.825l-.022-.294c-.085-1.12-.128-1.706-.128-2.906v-.027c.025-1.291.05-2.607.15-3.923.075-.95.65-1.725 1.35-1.825h10.368l-4.94 4.338-2.125-1.953-2.427 2.13 4.523 4.157L22 6.25V3H6.525c-2.35.2-4.2 2.25-4.375 4.85-.1 1.4-.15 2.8-.15 4.175 0 1.315.046 1.97.137 3.224l.013.176c.175 2.6 2.025 4.65 4.375 4.85"
      }
    )
  }
);
export {
  e as default
};
